exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-navigation[data-v-3dfb5f06]{position:relative;display:-ms-flexbox;display:flex;width:100%;height:60px;background:#fff;z-index:9}.bottom-navigation .navigation-item[data-v-3dfb5f06]{display:-ms-flexbox;display:flex;-ms-flex-line-pack:center;align-content:center;-ms-flex-pack:center;justify-content:center;text-align:center}.bottom-navigation .navigation-item .navigation-icon[data-v-3dfb5f06]{padding-top:10px;color:#ffb403}.bottom-navigation .navigation-item .navigation-box>p[data-v-3dfb5f06]{font-size:13px}", ""]);

// exports
